module.exports = __webpack_public_path__ + "img/roulette-base.e423cb22.png";